import React from 'react';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose}) => {
  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 flex items-center justify-center z-20 overflow-auto backdrop-blur">
      <div className="fixed inset-0 bg-purple-50 dark:bg-dark-800 fade-in " onClick={onClose}></div>
      <div className="bg-white dark:bg-dark-600 relative py-14 px-10 rounded-3xl shadow-lg z-10 max-w-md mx-4 w-full max-h-full overflow-y-auto bg-opacity-50 ">
        <button onClick={onClose} className='absolute right-0 top-0 p-5 text-2xl text-gray-300'><FontAwesomeIcon icon={faClose}></FontAwesomeIcon></button>
        <h2 className="text-center text-5xl font-bold">Тест Бөглөх</h2>
        <div className='mt-6'>
          <Link href="/test">
          <button
            className="transition-transform duration-150 ease-in-out transform active:scale-95 mt-4 px-4 py-5 bg-purple-500 font-bold text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-opacity-50 w-full"
          >
            Бөглөж эхлэх
          </button>
          </Link>
          <div className='mt-4 text-center text-sm'>Бидний боловсруулсан тестийг бөглөж өөрийн мэдээллээ аваарай.</div>
        </div>
      
        <div className='mt-5 pt-5 border-t-2 border-gray-200'>
          <div className='text-center font-semibold text-gray-600 dark:text-white text-sm'>Нэвтрэх эсвэл бүртгүүлэх үү?</div>
          <Link  href="/login">
          <div className='mt-0 text-sm font-semibold text-center underline hover:cursor-pointer'>Нэвтрэх</div>
          </Link>
        </div>
        
      </div>
    </div>
  );
};

export default LoginModal;
